import {API, APIv2} from "../api";
import {
    AddFacilityPayload,
    AddFactoryPayload,
    EditFacilityPayload,
    EditFactoryPayload,
    IFacility
} from "../../FactoryGame/types";

export const SatisfactoryAPI = {
    Facility: {
        fetch: async () => {
            return await APIv2.get<{ [id: number]: IFacility }[]>('FactoryGame/Facility/');
        },
        addFacility: async (facility: AddFacilityPayload): Promise<void> => {
            await APIv2.post<void>('FactoryGame/Facility/addFacility', facility);
        },
        addFactory: async (factory: AddFactoryPayload): Promise<void> => {
            await APIv2.post<void>('FactoryGame/Facility/addFactory', factory);
        },
        editFacility: async (facility: EditFacilityPayload): Promise<void> => {
            await APIv2.patch<void>('FactoryGame/Facility/' + facility.id, facility);
        },
        editFactory: async (factory: EditFactoryPayload): Promise<void> => {
            await APIv2.patch<void>('FactoryGame/Facility/' + factory.id, factory);
        },
        deleteFacility: async (facility: IFacility): Promise<void> => {
            await APIv2.delete<void>('FactoryGame/Facility/' + facility.id);
        },
    }
}
